import { Activity } from "botframework-directlinejs";
import WebchatBotChatBubble from "@Components/CustomerApp/BotConversationView/WebchatBotChatBubble/WebchatBotChatBubble";

export const renderWebchatBotChatBubble = (
    activity: Activity,
    chatId: string,
    isFirstConsecutive: boolean,
    isLastConsecutive: boolean,
    isLastMessage: boolean
): React.ReactNode => {
    return (
        <WebchatBotChatBubble
            activity={activity}
            chatId={chatId}
            isFirstConsecutive={isFirstConsecutive}
            isLastConsecutive={isLastConsecutive}
            isLastMessage={isLastMessage}
        />
    );
};
